(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/back-to-game-info.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/back-to-game-info.js');
'use strict';

const {
  ReactBrand: Brand
} = svs.ui;
const BackToGameInfo = _ref => {
  let {
    branding,
    isInRegisterFlow = true
  } = _ref;
  return React.createElement("div", {
    className: "padding-1 bg-tur-100 margin-bottom-2 u-flex u-border-radius-12 u-flex-align-items-center"
  }, branding && React.createElement("div", {
    className: "margin-right-1"
  }, React.createElement(Brand, {
    brand: branding,
    className: "reg-brand-square",
    square: true
  })), React.createElement("p", {
    className: "h4 margin-bottom-0"
  }, React.createElement("span", {
    className: "f-medium "
  }, "Efter ".concat(isInRegisterFlow ? 'registrering' : 'insättningen', " hj\xE4lper vi dig tillbaka till spelet."))));
};
svs.playerRegistration.components.BackToGameInfo = BackToGameInfo;

 })(window);